import api from './api';

// Wraps POST /api/ai-tools/flight-search (backend/routes/ai-tools.js), which
// uses travelPricingService's Amadeus integration (see
// backend/services/travelPricingService.js searchFlights()). Mirrors the
// existing hotel-search pattern used by AIToolsPage.jsx.
export const flightSearchService = {
  // params: { origin, originName, destination, destinationName, departDate,
  //           returnDate, adults, travelClass }
  searchFlights: async (params) => {
    const response = await api.post('/ai-tools/flight-search', params);
    return response.data;
  },

  // Typeahead for the "From"/"To" fields - returns [{iataCode, name, cityName, type}]
  getAirportSuggestions: async (query) => {
    const response = await api.get('/ai-tools/airport-suggestions', { params: { query } });
    return response.data;
  }
};
